<template>
  <ButtonGroup class="links">
    <Button
      name="Albanian"
      :type="_i18n.locale === 'sh' ? 'primary' : 'default'"
      @click="changeLanguage('sh')"
      size="large"
    >AL</Button>
    <Button
      name="English"
      :type="_i18n.locale === 'en' ? 'primary' : 'default'"
      @click="changeLanguage('en')"
      size="large"
    >EN</Button>
  </ButtonGroup>
</template>
<script>
import EventBus from './EventBus';

export default {
  methods: {
    changeLanguage(locale) {
      this._i18n.locale = locale;
      EventBus.$emit('changed-locale');
    },
  },
};
</script>


<style lang="scss">
.links {
  margin-bottom: 20px;
}
</style>
